// RedirectIfAuthed — used on /login + /register; sends already-logged-in
// users to /dashboard (or to ``?next=`` if explicitly provided).

import { Navigate, useSearchParams } from "react-router-dom";
import { type ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth/AuthProvider";

interface RedirectIfAuthedProps {
  children: ReactNode;
}

export function RedirectIfAuthed({ children }: RedirectIfAuthedProps) {
  const auth = useAuth();
  const [params] = useSearchParams();
  const next = params.get("next");

  if (auth.status === "loading") {
    return (
      <div
        data-testid="redirect-if-authed-loading"
        className="min-h-[100dvh] flex items-center justify-center bg-paper text-ink-2"
      >
        <Loader2 className="w-6 h-6 animate-spin" aria-hidden />
        <span className="sr-only">載入中</span>
      </div>
    );
  }

  if (auth.status === "authenticated") {
    const dest = next && next.startsWith("/") ? next : "/dashboard";
    return <Navigate to={dest} replace />;
  }

  return <>{children}</>;
}
